import type { FaireProductEntity } from "../../entity_types/product";

export const p_6k6zwggfqh: FaireProductEntity = {
  token: "p_6k6zwggfqh",
  type: "product",
  name: "Cotton Linen A-Line Sundress",
  brandToken: "b_5thtu28bhh",
  brandName: "Hope & Sunshine",
  imageUrl:
    "https://cdn.faire.com/fastly/8e3ebd1e0797fbae8487acc015e8ab8bc49fef3bb6d4aea2a11e3e1025587c7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a9f55ca24f2a95f4492c404ab1e94da78edd1e5536eb5d317c1da8d1df5791fe.jpeg",
    "https://cdn.faire.com/fastly/9edca87a950fb548967ca2665357829d5c13c84c0a8156a61138da01785ca7e0.jpeg",
    "https://cdn.faire.com/fastly/037ec37652db0b68dbad28a51c759856f0bf3a2f36a8fead0a7abcccccad9e18.jpeg",
    "https://cdn.faire.com/fastly/7df83ee8e37d2b99fbf17c871096973f3828c59ae26dd71089d6443678c93a92.jpeg",
    "https://cdn.faire.com/fastly/7d3edb66298090314e9e38dc068b62e4259c6441b22408672058d8ac58eef498.jpeg",
    "https://cdn.faire.com/fastly/b55a857d8d24da79a1c67680d4deeb597e4f31aa3f933c95ad4f2757b2fcbec8.jpeg",
    "https://cdn.faire.com/fastly/020137a7cc3968caa26e97001a7cbc408f4c96d79e3aafd2ca6f546209d6fc94.jpeg",
    "https://cdn.faire.com/fastly/28840457925d52ba74714e9da712a44c777e39c61f452e335c9bebd50a862fa2.jpeg",
    "https://cdn.faire.com/fastly/7db28b67e63ea215ffb2d5a797d40abe1a778c8b552d307bd9664f9fa9a097ff.jpeg",
    "https://cdn.faire.com/fastly/087eccf0c5e5d62112606fcd7589949b7a28dd1983734ade3c187792021a5f45.jpeg",
    "https://cdn.faire.com/fastly/0ad546f3b92baadef846b9eaaaa24f2e3b9c03679bcb9a527cff01532e0383c8.jpeg",
    "https://cdn.faire.com/fastly/2cb969cfdc48e7e35e8a2c907007b51d1487d2ffe833d3c3a967ad2e649a6b78.jpeg",
    "https://cdn.faire.com/fastly/1b8abc40d14c7a65f4e3964658379b0c202ed37f2781b6c7fb8c1dc06e97a666.jpeg",
    "https://cdn.faire.com/fastly/335872e091a228bd01d1062cd52ff4bae84d4cf7c78a06ae29a77216882e72f2.jpeg",
    "https://cdn.faire.com/fastly/5f09630cd9f630d5099a2861d4598a7a6b133f1916fb20102743336e322452c0.jpeg",
    "https://cdn.faire.com/fastly/a24d8eccd5274f8ef435c8af0ae52c5387e741270f23a50595d3d06a0e72d76d.jpeg",
    "https://cdn.faire.com/fastly/f4496ea4262a350b7ee5534b0b226db2713c995449a8f760ef60317d49a93dff.jpeg",
    "https://cdn.faire.com/fastly/97c84625e9c74332e5499c6ca2aad68c89ee9afa99120eb4ab3de0d4b402bfe9.jpeg",
    "https://cdn.faire.com/fastly/b280acdae23081889612f9f555765c3b3376d524823c662558d05ccb681801e9.jpeg",
    "https://cdn.faire.com/fastly/9de3751a762c4acf5a15c5cdc697fca374a01fef33c3ccd4d8afa75c7c1a960b.jpeg",
  ],
  priceDollars: 14.8,
  description:
    "Made from a soft cotton-linen blend, this A-line dress features a relaxed fit, adjustable spaghetti straps, and a breezy, vacation-ready style inspired by effortless European fashion.",
  tags: [],
  msrpDollars: 29.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:58.182Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
